import { createRouter, createWebHistory } from 'vue-router' // createWebHashHistory
import Home from './views/Homepage.vue'
import Winner from './views/Winner.vue'

export const router = createRouter({
  history: createWebHistory(), // createWebHashHistory()
  routes: [
    { path: '/', name: 'home', component: Home },
    { path: '/winner', name: 'winner_list', component: Winner },
    {
      path: '/partner/friday', redirect: { name: 'home' }
    },
    {
      path: '/partner/00/friday', redirect: { name: 'home' }
    },
    {
      path: '/partner/:partnerCode(\\d+)',
      name: 'partner-code',
      children: [
        {
          path: ':partnerName',
          name: 'partner-code-name',
          component: Home,
        },
        {
          path: ':partnerName/winner',
          name: 'partner-code-name-winner-list',
          component: Winner,
        }
      ]
    },
    {
      path: '/partner/:partnerName',
      name: 'partner',
      component: Home,
    },
    {
      path: '/partner/:partnerName/winner',
      name: 'partner-winner-list',
      component: Winner,
    },
    { path: '/:pathMatch(.*)*', redirect: { name: 'home' } },
  ],
})
